import { StripeOrdersListScreen } from "../../Admin/Stripe/StripeOrdersListScreen.tsx";

export const AllStripeOrdersCloserScreenPath = "/closer/stripe/all-orders";

export function AllStripeOrdersCloserScreen() {
  return <StripeOrdersListScreen readOnly />;
}
